import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Referral from "./pages/Referral";
import Contact from "./pages/Contact";
import CryptoEducation from "./pages/CryptoEducation";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RiskDisclosure from "./pages/RiskDisclosure";
import KYC from "./pages/KYC";
import Documentation from "./pages/Documentation";
import Whitepaper from "./pages/Whitepaper";
import FAQ from "./pages/FAQ";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/referral" element={<Referral />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/learn" element={<CryptoEducation />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/risk" element={<RiskDisclosure />} />
            <Route path="/kyc" element={<KYC />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/whitepaper" element={<Whitepaper />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
